var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVteXlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 431,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VTEX_icon_pink_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 433,
    width: 506,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#f71963",
    id: "svg_2",
    d: "m465.146332,1.482688l-374,0c-29,0 -47.57,30.83 -34,56.46l37.43,70.84l-67.84,0a24.94,24.94 0 0 0 -22.06,36.56l120.33,227.75a24.94,24.94 0 0 0 44.08,0l32.68,-61.52l41,77.62c14.43,27.3 53.52,27.35 68,0.08l187.46,-352.76c13.25,-24.95 -4.83,-55.03 -33.08,-55.03zm-168,150.72l-80.83,152.14a16.6,16.6 0 0 1 -29.33,0l-80.05,-151.5a16.6,16.6 0 0 1 14.67,-24.35l161.28,0a16.15,16.15 0 0 1 14.26,23.71z",
    className: "a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVteXlogo);
export default __webpack_public_path__ + "static/media/VTEXlogo.8e9314eaea19acd4c6460cb073f71963.svg";
export { ForwardRef as ReactComponent };